import React from 'react';
import { Button } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import { v4 as uuidv4 } from 'uuid';
import { Form, Formik } from 'formik';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import Label from 'core/components/label/label';
import withDatePicker from 'core/components/with-date-picker';
import { FormField } from 'core/components/form';
import useStyles from './household-residents.styles';

const schema = Yup.object().shape({
  firstName: Yup.string().required('First Name is required'),
  lastName: Yup.string().required('Last Name is required'),
  dateOfBirth: Yup.string().required('Date of birth is required')
});

const AddResident = ({ onAdd, id, disabled }) => {
  const classes = useStyles();

  return (
    <Formik
      initialValues={{
        id: uuidv4(),
        firstName: '',
        lastName: '',
        dateOfBirth: '',
        pipEligible: true
      }}
      validateOnChange={false}
      validateOnBlur={false}
      validationSchema={schema}
      onSubmit={onAdd}
    >
      <Form className={classes.addResidentContainer}>
        <Label type="infoSubtitle" className={classes.addResidentsTitle}>
          Add a household resident
        </Label>
        <Grid container alignItems="center" justifyContent="flex-end" spacing={2}>
          <Grid item xs={4}>
            <FormField
              id="firstName"
              name="firstName"
              type="string"
              label="First Name"
              mode="light"
              disabled={disabled}
            />
          </Grid>
          <Grid item xs={4}>
            <FormField id="lastName" name="lastName" type="string" label="Last Name" mode="light" disabled={disabled} />
          </Grid>
          <Grid item xs={4}>
            <FormField
              id="dateOfBirth"
              name="dateOfBirth"
              type="date"
              label="Date of Birth"
              mode="light"
              disabled={disabled}
              defaultToEmpty
            />
          </Grid>
          <Grid item xs={4}>
            <Button
              key="addButton"
              className={classes.button}
              type="submit"
              variant="contained"
              color="secondary"
              disabled={disabled}
            >
              Add household resident
            </Button>
          </Grid>
        </Grid>
      </Form>
    </Formik>
  );
};

AddResident.propTypes = {
  onAdd: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired
};

export default withDatePicker(AddResident);
